module.exports = __webpack_public_path__ + "static/media/32 - Jungle - Heavy, California.3eb6c8cf.mp3";